import { createClient } from '@/shared/api';
import type { RestoreStudyMutation, RestoreStudyMutationVariables } from '@/shared/api';
import RESTORE_STUDY_MUTATION from '../mutations/restoreStudy';

/**
 * Restores a previously deleted study. Runs RESTORE_STUDY_MUTATION and throws restoreStudy.message when isSuccess is false.
 *
 * @param studyId - Identifier of the study to restore.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleRestoreStudy = async (studyId: any) => {
  const client = createClient();
  const restoreStudyResult = await client.mutate<
    RestoreStudyMutation,
    RestoreStudyMutationVariables
  >({
    mutation: RESTORE_STUDY_MUTATION,
    variables: {
      studyId,
    },
  });
  const { data } = restoreStudyResult;
  const { restoreStudy } = data ?? {};
  if (!restoreStudy?.isSuccess) {
    throw new Error(restoreStudy?.message ?? undefined);
  }
};

export default handleRestoreStudy;
